var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayerX00201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_413082784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.70035 4.68541L4.70007 4.68569C-0.398448 9.82435 -0.398646 18.1744 4.70021 23.2934L4.70049 23.2937C9.81941 28.3925 18.1695 28.3923 23.3082 23.2938L23.3087 23.2932C28.3875 18.1743 28.3873 9.82446 23.3089 4.68582L23.3083 4.68527C18.1696 -0.433356 9.81931 -0.433554 4.70035 4.68541ZM23.8445 23.8094L23.8443 23.8095C21.1349 26.5189 17.575 27.864 13.9944 27.864C10.4338 27.864 6.87392 26.519 4.16446 23.8095C-1.25489 18.3901 -1.2547 9.54891 4.16433 4.14965C9.58359 -1.24984 18.425 -1.24988 23.8443 4.14952C29.2637 9.56887 29.2635 18.4101 23.8445 23.8094Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.0756 31.3973L33.0757 31.3968C33.2022 30.9329 33.2207 30.1946 32.4912 29.5059L24.8824 21.8773L24.8824 21.8772C24.7222 21.717 24.7222 21.4815 24.8824 21.3214C25.0225 21.1812 25.2777 21.1812 25.418 21.3212C25.4181 21.3212 25.4182 21.3213 25.4182 21.3214L33.0276 29.0303L33.028 29.0308C33.6856 29.6884 33.9233 30.4274 33.8755 31.1271C33.8276 31.8294 33.4915 32.4999 32.9879 33.0133C32.4931 33.5079 31.8309 33.8325 31.1887 33.8975C31.1148 33.8601 31.0429 33.8602 30.9926 33.8602L30.9871 33.8602C30.279 33.8602 29.6066 33.5737 29.0459 33.0131L29.0458 33.013L21.4181 25.3654C21.2753 25.2048 21.2752 24.9663 21.418 24.8057C21.5781 24.6474 21.8124 24.648 21.9719 24.8075L29.6016 32.4373C29.9427 32.7784 30.2884 32.9531 30.6153 33.0222C30.9406 33.0909 31.2409 33.0538 31.4914 32.981C32.2452 32.7918 32.8676 32.1458 33.0756 31.3973Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.59568 17.4868C8.37201 17.4868 8.19766 17.3125 8.19766 17.0888V12.3277C8.19766 12.1266 8.36934 11.9496 8.59568 11.9496C8.80473 11.9496 8.9937 12.1291 8.9937 12.3277V17.1007C8.95677 17.3186 8.7729 17.4868 8.59568 17.4868Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.2011 17.4867C11.9775 17.4867 11.8031 17.3124 11.8031 17.0887V9.8574C11.8031 9.63373 11.9775 9.45938 12.2011 9.45938C12.4248 9.45938 12.5992 9.63373 12.5992 9.8574V17.1046C12.5812 17.3143 12.4024 17.4867 12.2011 17.4867Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8271 17.4868C15.6035 17.4868 15.4291 17.3125 15.4291 17.0888V12.3277C15.4291 12.1266 15.6008 11.9496 15.8271 11.9496C16.0535 11.9496 16.2251 12.1266 16.2251 12.3277V17.1047C16.2164 17.2046 16.1655 17.3005 16.0896 17.3723C16.0125 17.4452 15.9166 17.4868 15.8271 17.4868Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.4526 17.4873C19.2289 17.4873 19.0546 17.3129 19.0546 17.0893V9.57908C19.0546 9.35541 19.2289 9.18105 19.4526 9.18105C19.659 9.18105 19.8506 9.35798 19.8506 9.57908V17.1012C19.8137 17.3191 19.6298 17.4873 19.4526 17.4873Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M21.3053 17.4869H6.74314C6.51948 17.4869 6.34512 17.3125 6.34512 17.0888C6.34512 16.8652 6.51948 16.6908 6.74314 16.6908H21.3053C21.5117 16.6908 21.7033 16.8677 21.7033 17.0888C21.7033 17.1963 21.6534 17.2958 21.5752 17.3698C21.4962 17.4446 21.3955 17.4869 21.3053 17.4869Z",
    fill: "#01FF85",
    stroke: "#182A2E",
    strokeWidth: 0.2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerX00201);
export default __webpack_public_path__ + "static/media/Layer_x0020_1.0889b67340e8e3eb59e161e790c388fa.svg";
export { ForwardRef as ReactComponent };